import type mdast from 'mdast';
import remarkStringify from 'remark-stringify';
import { unified } from 'unified';
import { replaceEndingNewLine } from '../whitespace';
import { stringifyStrikethrough } from './remark/stringifyStrikethrough';
import { text } from './remark/textHandler';

const processor = unified()
  .use(remarkStringify, {
    fences: true,
    emphasis: '*',
    listItemIndent: 'one',
    resourceLink: true,
    bullet: '-',
    handlers: {
      // We don't want to escape soft line breaks in Front-flavored Markdown.
      break: () => '\n',
      // We don't want HTML at all.
      html: () => '',
      text,
    },
  })
  .use(stringifyStrikethrough);

export function markdownAstToString(node: mdast.Root | mdast.Content): string {
  const nodeWithRoot: mdast.Root = node.type === 'root' ? node : { type: 'root', children: [node] };
  // remarkStringify now uses mdast-util-to-markdown to serialize which adds a final \n, since we are not producing POSIX files or documents we don't render a final new line
  return replaceEndingNewLine(processor.stringify(nodeWithRoot));
}
